// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';

export async function setGuildNotificationSound(guildId: string, audio: string): Promise<void> {
	await http.put(Endpoints.GUILD_NOTIFICATION_SOUND(guildId), {body: {audio}});
}

export async function removeGuildNotificationSound(guildId: string): Promise<void> {
	await http.delete(Endpoints.GUILD_NOTIFICATION_SOUND(guildId));
}

export async function setChannelNotificationSound(channelId: string, audio: string): Promise<void> {
	await http.put(Endpoints.CHANNEL_NOTIFICATION_SOUND(channelId), {body: {audio}});
}

export async function removeChannelNotificationSound(channelId: string): Promise<void> {
	await http.delete(Endpoints.CHANNEL_NOTIFICATION_SOUND(channelId));
}
